function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "7.165",
  cy: "6.27",
  r: "5.27",
  stroke: "#191919",
  strokeWidth: "2",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.69 10.58l3.92 3.92",
  stroke: "#191919",
  strokeWidth: "2",
  strokeLinecap: "round"
})));